export default "<div>\n  <div class='map' id='map'></div>\n</div>\n"